module.exports = __webpack_public_path__ + "static/media/sidebar-1.462ae3f8.jpg";